import { render, staticRenderFns } from "./ChargebeeUpsellMarketingItem.vue?vue&type=template&id=2e72a344&"
import script from "./ChargebeeUpsellMarketingItem.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellMarketingItem.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellMarketingItem.vue?vue&type=style&index=0&id=2e72a344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports